/**
 * Whether a keyboard event started in a text field (an `<input>` or a `<textarea>`), so a
 * page-wide shortcut such as Shift+H or Escape can leave the user's typing alone.
 *
 * This used to be ten copies of `String(event.composedPath()[0]) === '[object HTMLInputElement]'`:
 * the same answer, read from the element's default stringification.
 */
export const isTextField = (event: Event): boolean => {
  const target = event.composedPath()[0];

  return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement;
};
